import { formatBooleanValue } from "../../util";
import GenericCodebookItem from "../model/GenericCodebookItem";

const GenericCodebookItemMapper = (item: any) => {
  let organisation = GenericCodebookItem(item);
  organisation.valid = formatBooleanValue(item.valid);
  return organisation;
};
export default GenericCodebookItemMapper;
